<app-auth-view>
  <ng-container slot="title">Inloggen</ng-container>
  <ng-container slot="message">
    Welkom terug! We zijn blij je weer te zien. Log in om toegang te krijgen tot je
    account.
  </ng-container>

  <ng-container slot="content">
    @if (logoutReason(); as reason) {
      <div class="mt-6 bg-amber-50 border border-amber-200 rounded-lg p-3 text-sm text-amber-900">
        {{ reason }}
      </div>
    }
    <app-login-form class="block mt-10" />
  </ng-container>
</app-auth-view>
